import styled from 'styled-components';

export default styled.div`
  background-image: ${(p) => p.theme.colors.gradientBackground};
  height: 100%;
`;
